export function addParam(paramName, paramValue) {
    let url = window.location.href;
    let hash = location.hash;
    url = url.replace(hash, "");
    if (url.indexOf(paramName + "=") >= 0) {
        
        let prefix = url.substring(0, url.indexOf(paramName));
        let suffix = url.substring(url.indexOf(paramName));
        suffix = suffix.substring(suffix.indexOf("=") + 1);
        suffix =
            suffix.indexOf("&") >= 0
                ? suffix.substring(suffix.indexOf("&"))
                : "";
        url = prefix + paramName + "=" + paramValue + suffix;
        
    } else {
        if (url.indexOf("?") < 0) url += "?" + paramName + "=" + paramValue;
        else url += "&" + paramName + "=" + paramValue;
    }
    console.log('url', url);
    window.history.pushState({ url: url }, document.title, url); // added this line to push the new url directly to url bar .
}

export function addParams(params) {
    let url = window.location.href;
    let hash = location.hash;
    url = url.replace(hash, "");
    url = url.replace(window.location.origin, "");
    
    
    // if (url.indexOf("?") < 0) url += "?" + params
    // else url += "&" + params
    url += "&" + params
    return url;
}

export function removeParam(parameter) {
    let url = document.location.href;
    let urlparts = url.split("?");

    if (urlparts.length >= 2) {
        let urlBase = urlparts.shift();
        let queryString = urlparts.join("?");

        let prefix = encodeURIComponent(parameter) + "=";
        let pars = queryString.split(/[&;]/g);
        for (let i = pars.length; i-- > 0; )
            if (pars[i].lastIndexOf(prefix, 0) !== -1) pars.splice(i, 1);
        url = urlBase + "?" + pars.join("&");

        window.history.pushState({ url: url }, document.title, url); // added this line to push the new url directly to url bar .
    }
    return url;
}

export function getParameterByName(name, url) {
    if (!url) url = window.location.href;
    name = name.replace(/[\[\]]/g, "\\$&");
    let regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
      results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, " "));
}